// Statut d'un article (rupture / stock bas / négatif / normal), calculé une
// seule fois ici et réutilisé par toutes les dispositions d'affichage du
// Stock (grille, tableau, liste compacte, groupé par catégorie, priorité) —
// garantit que le même article a toujours le même statut, peu importe la
// disposition choisie par l'utilisateur.
export function getArticleStatus(a, isTestMode) {
  const qty = Number(a.quantite ?? 0);
  const isNegative = qty < 0;
  const isOutOfStock = qty === 0;
  // Stock bas : si un seuil d'alerte est configuré sur l'article, on s'y fie
  // strictement. Sinon, on retombe sur l'ancienne estimation par défaut (2
  // unités ou moins) pour ne rien changer au comportement des articles sans
  // seuil configuré.
  const hasSeuil = a.seuil_alerte !== null && a.seuil_alerte !== undefined;
  const isLow = !isNegative && !isOutOfStock && (hasSeuil ? qty <= Number(a.seuil_alerte) : qty <= 2);
  const key = isNegative ? "negative" : isOutOfStock ? "out" : isLow ? "low" : "ok";
  const label = isNegative ? "Stock négatif" : isOutOfStock ? "Produits hors stock" : isLow ? "Stock bas" : "En stock";
  return { qty, isNegative, isOutOfStock, isLow, key, label };
}

// Classes Tailwind associées à chaque statut, dans les variantes utilisées à
// travers les différentes dispositions (bordure de carte, texte de badge,
// fond de badge, texte de quantité).
export const STATUS_CLASSES = {
  negative: {
    card: "border-destructive bg-destructive/10",
    text: "text-destructive",
    badgeBg: "bg-destructive/15",
    badgeText: "text-destructive",
    dot: "bg-destructive",
  },
  out: {
    card: "border-slate-400 bg-slate-500/10",
    text: "text-slate-500 dark:text-slate-400",
    badgeBg: "bg-slate-500/15",
    badgeText: "text-slate-500 dark:text-slate-400",
    dot: "bg-slate-400",
  },
  low: {
    card: "border-amber-500 bg-amber-500/10",
    text: "text-amber-600 dark:text-amber-400",
    badgeBg: "bg-amber-500/15",
    badgeText: "text-amber-600 dark:text-amber-400",
    dot: "bg-amber-500",
  },
  ok: {
    card: "border-border bg-card",
    text: "",
    badgeBg: "bg-emerald-500/15",
    badgeText: "text-emerald-600 dark:text-emerald-400",
    dot: "bg-emerald-500",
  },
};

// Les 5 dispositions proposées pour la page Stock — libellé affiché dans le
// menu déroulant, et clé de stockage de la préférence (locale au
// navigateur : c'est un réglage d'affichage personnel, pas une donnée
// métier à synchroniser entre appareils).
export const STOCK_VIEW_MODES = [
  { value: "grille", label: "Grille de cartes" },
  { value: "tableau", label: "Tableau dense" },
  { value: "liste", label: "Liste compacte" },
  { value: "groupe", label: "Groupé par catégorie" },
  { value: "priorite", label: "Priorité stock" },
];

export const STOCK_VIEW_STORAGE_KEY = "sogogestion_stock_view_mode";
